<template>
  <div class="navbar bg-base-200 w-full">
    <div class="flex-1">
      <RouterLink to="/" class="btn btn-ghost text-xl">{{ $t('global.app-name') }}</RouterLink>
    </div>
    <div class="flex-none">
      <!-- Named router-view: each route can supply its own navbar content -->
      <RouterView name="navbar" />
    </div>
    <progress v-if="isLoading" class="progress progress-primary absolute inset-x-0 top-0 h-0.5" />
  </div>
</template>

<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router';
import { useLoading } from '../stores/loadingStore';

const { isLoading } = useLoading();
</script>
